import React from 'react';
import './InputFeedbackWhite.css';

const InputFeedbackWhite = ({ error }) => (
  <div className="input-feedback-white">{error ? error : null}</div>
);

export default InputFeedbackWhite;
